import {
  KIOSK_CART_RECOMMENDATION_CARDS_BLOCK_COMPONENT,
  KIOSK_SUGGESTIONS_MODAL_BLOCK_COMPONENT,
} from './cb2-preview-bloc-types';
import type { Cb2PreviewScenarioPayload } from './cb2-preview-protocol';

const KIOSK_SUGGESTIONS_PREVIEW_BLOC_TYPES = new Set<string>([
  KIOSK_SUGGESTIONS_MODAL_BLOCK_COMPONENT,
  KIOSK_CART_RECOMMENDATION_CARDS_BLOCK_COMPONENT,
]);

/**
 * Both kiosk cart launchers share `kiosk-suggestions-modal`. A closed scenario
 * must not dismiss the modal while the other launcher's preview scenario is open.
 */
export function isAnyKioskSuggestionsPreviewModalOpen(
  scenarios: Readonly<Record<string, Cb2PreviewScenarioPayload>> | null | undefined,
): boolean {
  if (!scenarios) {
    return false;
  }

  return Object.values(scenarios).some(scenario => {
    if (!KIOSK_SUGGESTIONS_PREVIEW_BLOC_TYPES.has(scenario.blocType)) {
      return false;
    }
    const data = scenario.data;
    if (!data || typeof data !== 'object') {
      return false;
    }
    return (data as { isOpen?: unknown }).isOpen === true;
  });
}
